module.exports = __webpack_public_path__ + "img/services-3.9af6fd8b.png";